export enum MediaOriginEnum {
    Server = 1,
    Amazon = 2,
    Cloudinary = 3
}